<template>
  <div class="seven-container" id="scrollTo">
    <!-- 筛选项  -->
    <el-card class="filter-card" id="4" shadow="hover">
      <div slot="header" class="card-header">
        <span class="card-title">
          <i class="el-icon-search"></i>
          筛选条件
        </span>
      </div>
      <el-form
        ref="form"
        :inline="true"
        label-position="right"
        label-width="90px"
        :model="reqForm"
        @submit.native.prevent
        class="filter-form filter-form--compact"
      >
        <div class="form-grid form-grid--compact">
          <el-form-item label="景区名称" class="form-item">
            <el-select
              @change="givedevice"
              v-model="reqForm.company_id_list"
              clearable
              filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in storeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称" class="form-item">
            <el-select
              v-model="reqForm.device_id_list"
              clearable
              filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                fetchData
                v-for="item in deviceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="支付时间" class="form-item">
            <el-date-picker
              v-model="timeRange"
              end-placeholder="结束日期"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </div>
        <div class="form-actions">
          <el-button type="primary" @click="fetchData">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button type="success" @click="downloadOrderDetail">
            <i class="el-icon-download"></i>
            订单明细
          </el-button>
        </div>
      </el-form>
      <el-collapse v-model="activeNames" @change="handleChange" class="dashboard-collapse">
        <el-collapse-item title="仪表盘" name="2" class="dashboard-item">
          <chaertstable :sevenlist="sevenlist"></chaertstable>
        </el-collapse-item>
      </el-collapse>
    </el-card>
    <el-card class="content-card" shadow="hover">
      <!-- 综合数据 -->
      <div class="changetable" id="1">
        <div class="card-header">
          <span class="card-title">
            <i class="el-icon-data-line"></i>
            综合数据
          </span>
        </div>
        <el-table ref="tableSort" border :data="countDataList">
          <el-table-column
            align="center"
            label="计入统计设备"
            prop="总台数"
            show-overflow-tooltip
            width="180"
          />
          <el-table-column
            align="center"
            label="总计金额"
            prop="总计"
            show-overflow-tooltip
            width="180"
          />
          <el-table-column
            align="center"
            label="银联"
            prop="银联"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            label="工行"
            prop="工行"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            label="微信"
            prop="微信"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            label="支付宝"
            prop="支付宝"
            show-overflow-tooltip
          />
        </el-table>
        <el-table ref="tableSort" border :data="dataList" height="330" stripe>
          <el-table-column
            align="center"
            label="设备名称"
            prop="name"
            show-overflow-tooltip
            width="180"
          />
          <el-table-column
            align="center"
            label="总计金额"
            prop="总计"
            show-overflow-tooltip
            width="180"
          />
          <el-table-column
            align="center"
            label="银联"
            prop="银联"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            label="工行"
            prop="工行"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            label="微信"
            prop="微信"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            label="支付宝"
            prop="支付宝"
            show-overflow-tooltip
          />
        </el-table>
      </div>
    </el-card>
    <!-- 实现电梯导航 -->
    <!-- <div class="elevator" @mouseenter="changetable" @mouseleave="seetable" id="elevator">
        <div v-for="item in navlist" :key="item.id" class="gonav">
          <el-button @click="changenav(item.id)">{{ item.value }}</el-button>
        </div>
      </div> -->
  </div>
</template>
<script>
import { getStoreList, getDeviceList, getdata, export777OrderDetail } from "@/api/seven";
import chaertstable from "./charts.vue";
import * as echarts from "echarts";
export default {
  name: "Statistics",
  components: {
    chaertstable,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sevenlist:[],
      activeNames: ["2"],
      storeList: [], // 景区列表
      deviceList: [], // 设备列表
      tabledata: [], //  表格数据
      dataList: [],
      payMapList: [],
      countDataList: [],
      timeRange: [],
      reqForm: {
        company_id_list: [],
        device_id_list: [],
      },
      navlist: [
        {
          id: 1,
          value: "综合数据",
        },
        // {
        //   id: 2,
        //   value: "大牌数据",
        // },
        // {
        //   id: 3,
        //   value: "纪念章数据",
        // },
        // {
        //   id: 4,
        //   value: "回到顶部",
        // },
      ],
      pickerOptions: {
        disabledDate(time) {
          // time.getTime() > 今天零点时间戳 → 禁用
          const todayZero = new Date(new Date().toLocaleDateString()).getTime();
          return time.getTime() >= todayZero;
        }
      },
    };
  },
  created() {
    if (this.type == 3 || this.type == 1) {
      this.getAllStore();
      this.setDefaultDate();
    }
  },
  mounted() {
    if (this.type == 3 || this.type == 1) {
      this.fetchData();
    }
  },
  methods: {
    // 获取景区所在设备
    givedevice() {
      //   获取设备列表
      getDeviceList({
        company_id_list: this.reqForm.company_id_list,
      })
        .then((res) => {
          if (res.code == 2000) {
            this.deviceList = res.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 校验明细下载时间跨度（不超过三个自然月）
    validateDetailDateRange(start, end) {
      if (!start || !end) {
        this.$message.error("请选择支付时间");
        return false;
      }
      const parseLocalDate = (value) => {
        const [year, month, day] = value.split("-").map(Number);
        return new Date(year, month - 1, day);
      };
      const startDate = parseLocalDate(start);
      const endDate = parseLocalDate(end);
      if (endDate < startDate) {
        this.$message.error("结束日期不能早于开始日期");
        return false;
      }
      const maxEnd = new Date(startDate);
      maxEnd.setMonth(maxEnd.getMonth() + 3);
      if (endDate > maxEnd) {
        this.$message.error("查询订单明细不能超过三个月");
        return false;
      }
      return true;
    },
    // 下载 777 订单明细
    downloadOrderDetail() {
      const queryForm = this.getReq();
      if (!this.validateDetailDateRange(queryForm.start, queryForm.end)) {
        return;
      }
      export777OrderDetail({
        start: queryForm.start,
        end: queryForm.end,
        company_id_list: queryForm.company_id_list,
        device_id_list: queryForm.device_id_list,
      })
        .then((resp) => {
          this.download(resp, `777订单明细${queryForm.start}-${queryForm.end}.xlsx`);
        })
        .catch((error) => {
          if (error && error.msg) {
            // 全局 blob 拦截器已提示，这里避免重复；无 msg 时兜底
            return;
          }
          this.$message.error("下载失败");
          console.log("报错信息", error);
        });
    },
    download(resp, fileName) {
      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(href);
      }
    },
    handleChange(val) {
    },
    changetable() {
      const elevator = document.getElementById("elevator");
      elevator.style.opacity = "1"; // 设置透明度为 1
    },
    seetable() {
      const elevator = document.getElementById("elevator");
      elevator.style.opacity = "0.2"; // 设置透明度为 0.2
    },
    // 电梯导航
    changenav(val) {
      let scr = document.getElementById(val);
      let containertop = scr.offsetTop;
      if (scr) {
        scr.scrollIntoView({ behavior: "smooth" });
      }
    },
    // 查询数据
    fetchData() {
      var queryForm = this.getReq();
      getdata({
        start: queryForm.start, // 开始日期
        end: queryForm.end, // 结束日期
        company_id_list: queryForm.company_id_list, // 景区id
        device_id_list: queryForm.device_id_list, // 景区id
      })
        .then((res) => {
          if (res.code == 2000) {
            this.dataList = res.data.deviceMapList;
            this.dataList = res.data.deviceMapList;
              this.dataList.forEach(item => {
              item.total = item['总计']; // 将 total 属性改为 value 属性
            });
            this.payMapList = res.data.payMapList;
            this.countDataList = res.data.totalMapList;
            // let bar = this.optionPie;
            this.sevenlist = res.data.payMapList
            // bar.series[0].data = res.data.payMapList;
            // this.renderPieChart(bar);
          } else {
            this.tabledata = [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getReq() {
      var queryForm = { ...this.reqForm };
      if (this.timeRange != null) {
        const [startDate, endDate] = this.timeRange;
        queryForm.start = this.formatDate(startDate); // 不需要调用 startDate.getTime()
        queryForm.end = this.formatDate(endDate); // 不需要调用 endDate.getTime()
      } else {
        queryForm.start = "";
        queryForm.end = "";
      }

      queryForm.company_id_list =
        queryForm.company_id_list.length > 0 ? queryForm.company_id_list : [];

      queryForm.device_id_list =
        queryForm.device_id_list.length > 0 ? queryForm.device_id_list : [];
      return queryForm;
    },

    // 传递时间组件
    setDefaultDate() {
      const today = new Date() // 获取当前时间
      today.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为当天的 00:00:00.000

      const yesterdayStart = new Date(today) // 创建一个昨天的副本
      yesterdayStart.setDate(today.getDate() - 1) // 将日期设置为昨天
      yesterdayStart.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为昨天的 00:00:00.000

      const yesterdayEnd = new Date(today) // 创建一个昨天的副本
      yesterdayEnd.setDate(today.getDate() - 1) // 将日期设置为昨天
      yesterdayEnd.setHours(23, 59, 59, 999) // 设置时、分、秒、毫秒为最大值，即将时间设置为昨天的 23:59:59.999

      this.timeRange = [yesterdayStart, yesterdayEnd]; // 设置当前时间范围
    },
    getAllStore() {
      //   获取景区列表
      getStoreList()
        .then((res) => {
          if (res.code == 2000) {
            this.storeList = res.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      //   获取设备列表
      getDeviceList()
        .then((res) => {
          if (res.code == 2000) {
            this.deviceList = res.data;
          }

        })
        .catch((e) => {
          console.log(e);
        });
    },
  }
};
</script>

<style scoped lang="scss">
.seven-container {
  min-height: 100vh;
  background: #f8f9fa;
  padding: 20px;
}

.filter-card {
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .card-header {
    background: #ffffff;
    color: #2c3e50;
    padding: 15px 20px;
    margin: -20px -20px 20px -20px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid #e9ecef;

    .card-title {
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .filter-form {
    .form-grid {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 6px 10px;
      margin-bottom: 8px;

      .form-item {
        margin: 0;
        ::v-deep .el-form-item__label {
          font-weight: 500;
          color: #2c3e50;
          font-size: 14px;
        }
      }
    }

    .form-actions {
      display: flex;
      gap: 6px;
      justify-content: flex-start;
      padding-top: 0;
      border-top: none;

      .action-btn {
        padding: 4px 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}

.dashboard-collapse {
  margin-top: 12px;

  .dashboard-item {
    ::v-deep .el-collapse-item__header {
      background: #ffffff;
      color: #2c3e50;
      border-radius: 6px;
      padding: 12px 16px;
      font-weight: 600;
      border: 1px solid #e9ecef;
    }

    ::v-deep .el-collapse-item__content {
      padding: 12px 0;
      background: white;
      border-radius: 0 0 6px 6px;
    }
  }
}

.content-card {
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .card-header {
    background: #ffffff;
    color: #2c3e50;
    padding: 15px 20px;
    margin: -20px -20px 20px -20px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid #e9ecef;

    .card-title {
      font-size: 18px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
}

.changetable {
  h2 {
    margin: 0 0 12px 0;
  }
}

@media (max-width: 768px) {
  .seven-container {
    padding: 12px;
  }

  .filter-card .filter-form .form-grid {
    grid-template-columns: 1fr;
  }

  .filter-card .filter-form .form-actions {
    flex-direction: column;

    .action-btn {
      width: 100%;
      justify-content: center;
    }
  }
}
</style>